export default [
    { key: 'editor', name: 'Editor' },
    { key: 'readonly-visible', name: 'Read' },
    { key: 'readonly-hidden', name: 'Invisible' },
];
